import { useQuery } from '@tanstack/react-query';
import { fetchTopDestinations } from 'flux/clients/locations';

export type TopDestination = {
  image?: string;
  location: { country: string; area: string; city?: string };
  host_count: number;
  experience_count: number;
  _id: string | number;
  _type: string;
};

export const useTopDestinations = () => {
  return useQuery({
    queryKey: ['topDestinations'],
    queryFn: async () => {
      const result = await fetchTopDestinations();
      const locationAreas = result.relations.filter(
        (relation) => relation._type === 'location_area',
      );
      const locationAreasJoined = locationAreas.map((locationArea) => ({
        ...locationArea,
        ...result.data.find((d) => d.id === locationArea._id),
      }));
      return locationAreasJoined as TopDestination[];
    },
    staleTime: 1000 * 60 * 60,
    placeholderData: [],
  });
};

export default useTopDestinations;
